export default "__VITE_ASSET__66Jb2K9v__"